import React, { useEffect, useId, useRef } from 'react';
import { X } from 'lucide-react';
import { tx } from './i18n';

// Presentation only. Ordering, equipment and requirements come from the API.
export { LabInstrument } from './LaboratoryInstruments';

export function LabDrawer({ title, eyebrow, children, onClose }) {
  const ref = useRef(null);
  const titleId = useId();
  useEffect(() => {
    const dialog = ref.current;
    const trigger = document.activeElement;
    dialog.showModal();
    return () => {
      if (dialog.open) dialog.close();
      if (trigger instanceof HTMLElement && trigger.isConnected) trigger.focus();
    };
  }, []);
  return <dialog ref={ref} className="xo-lab-drawer" aria-labelledby={titleId}
    onCancel={event => { event.preventDefault(); onClose(); }}
    onClick={event => {
      if (event.target !== event.currentTarget) return;
      const rect = event.currentTarget.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) onClose();
    }}>
    <header><div>{eyebrow && <small>{eyebrow}</small>}<h2 id={titleId}>{title}</h2></div>
      <button type="button" className="xo-icon-btn" aria-label={tx('ui.lab.visual.close')} onClick={onClose}><X aria-hidden="true" /></button>
    </header>
    <div className="xo-lab-drawer-body">{children}</div>
  </dialog>;
}
